module.exports = __webpack_public_path__ + "static/media/odd_favicon.83657ff0.png";